import { render, staticRenderFns } from "./DocumentsAdminAll.vue?vue&type=template&id=0bad8ce3"
import script from "./DocumentsAdminAll.vue?vue&type=script&lang=ts"
export * from "./DocumentsAdminAll.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bad8ce3')) {
      api.createRecord('0bad8ce3', component.options)
    } else {
      api.reload('0bad8ce3', component.options)
    }
    module.hot.accept("./DocumentsAdminAll.vue?vue&type=template&id=0bad8ce3", function () {
      api.rerender('0bad8ce3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/documents/admin/DocumentsAdminAll.vue"
export default component.exports